import { render } from "./AdminStepTour.vue?vue&type=template&id=7d2c9287&scoped=true&ts=true"
import script from "./AdminStepTour.vue?vue&type=script&lang=ts"
export * from "./AdminStepTour.vue?vue&type=script&lang=ts"

import "./AdminStepTour.vue?vue&type=style&index=0&id=7d2c9287&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2c9287"]])

export default __exports__